<template>
<div id="secure">

    <section class="main-content columns is-fullheight">
        <SideMenu />
        <div class="container column is-9">
            <loading :active.sync="isLoading" 
                :can-cancel="false" 
                :is-full-page="false">
            </loading>
            <div class="section">
                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Timesheet</p>
                    </div>
                    <div class="card-content">
                        <data-list v-bind:dataList="dataList"></data-list>
                    </div>
                </div>
                <br />

                <!-- <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Monthly Timesheet</p>
                    </div>
                    <div class="card-content">
                        <button class='button is-info is-small right' v-on:click="show()">View</button>
                        <div class="content"></div>
                    </div>
                </div>
                <br /> -->

            </div>
        </div>
    </section>
</div>
</template>

<script>
import SideMenu from '../../SideMenu'
import DataList from '../Attendance/DataList';
import axios from 'axios'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    name: 'AttendanceMain',
    components: {
        SideMenu,
        DataList,
        Loading
    },
    data() {
        return {
            isLoading: false,
            todayDate: '',
            dataList: [{
                firstName: '',
                lastName: '',
                checkIn: false,
                checkInTime: ''
            }]
        }
    },
    beforeMount() {
        this.$emit("authenticated", true)
        console.log('before mount in AddKelas')
        console.log("tokennn? " + localStorage.getItem('jwtToken'))
        console.log("email? " + localStorage.getItem('email'))
        console.log("sessionID? " + localStorage.getItem('sessionID'))
    },
    created() {
        var currentDate = new Date();
        //var todayDate = currentDate.getDate() + " " + currentDate.getMonth() + " " + currentDate.getFullYear() + " " + currentDate.getHours() + " " + currentDate.getMilliseconds();
        var currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            currentDay = "0" + currentDay;
        }
        var currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        if (currentMonth < 10){
            currentMonth = "0" + currentMonth;
        }
        this.todayDate = currentDate.getFullYear() + "" + currentMonth + "" + currentDay;
        this.getData()
        // Toast.open({
        //     color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
        //     message: 'Something happened correctly!',
        //     type: 'is-success',
        //     duration: 5000
        // })
    },
    methods: {   
//   show () {
//     this.$modal.show('hello-world');
//   },
//   hide () {
//     this.$modal.hide('hello-world');
//   },
        create(newData) {
            this.dataList.push(newData);
            
        },
        getData() {
            this.isLoading = true;
            let self = this
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            //axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/teachers/attendance', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        show: 'today',
                        actionDate: this.todayDate
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    console.log("imin 97")
        //              console.log(response)
                    self.dataList = response.data
                    self.isLoading = false;
                    console.log(self.dataList)
                })
                .catch(e => {
                    self.errors.push(e)
                    console.log(e)
                })
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Staff/Attendance/Main.vue